export default "__VITE_ASSET__Vy8cj$Ng__"